import { CurrentUser } from "@app/api/auth";
import { UserType } from "@core/enums/user-type";

import { CompanyUserModel } from "./user-company.model";
import { PrivateUserModel } from "./user-private.model";

export type TAllClients = PrivateUserModel & CompanyUserModel;

export interface UserModel {
  email: string;
  id: string;
  rights: Array<number>;
  userName: string;
  userType: UserType;
}

export class User implements UserModel {
  email = "";
  id = "";
  rights: Array<number> = [];
  userName = "";
  userType = UserType.private;

  constructor(dto?: User) {
    if (!dto) {
      return;
    }
    this.email = dto.email;
    this.id = dto.id;
    this.rights = dto.rights;
    this.userName = dto.userName;
  }

  static jsonSerialize(user: User): UserModel {
    return { ...user };
  }

  static parseDto(dto: UserModel): User {
    return new User({ ...dto });
  }

  static parseCurrentUser(dto: CurrentUser): User {
    return new User({
      id: dto.id,
      email: dto.email ?? dto.username,
      rights: dto.rights,
      userName: dto.username,
      userType: UserType.private,
    });
  }
}
